import React from "react";
import './index.scss';

const ChartValueCount = (data) => {
	console.log('sadsadsadasacg', data);

	return (
		<>
			<div className="chart-msg-blc d-flex flex-column align-items-center justify-content-center">
				<div className="msg d-inline-flex align-items-center">
					<span className="icon d-flex flex-column align-items-center justify-content-center">
						<img className="img-fluid" src={require('../../../assets/img/doc-icon.png')} alt="Document" />
					</span>
					<span className="txt">
						{data?.data[0].count}
						<span className="d-block">
							Docs in {data?.data[0].date}
						</span>
					</span>
				</div>
			</div>
		</>
	);

}
export default ChartValueCount;